export const INDUSTRY_PRESETS = [
  'Strategy & Leadership',
  'Product Management',
  'Engineering / Dev',
  'Design / UX',
  'Marketing & Growth',
  'Sales & BD',
  'Finance & Accounting',
  'HR & People Ops',
  'Legal / Compliance',
  'Data & Analytics',
  'Operations',
  'Content & Writing',
  'Fundraising',
  'Coaching / Mentoring',
];

export const CONTRIBUTION_PRESETS = [
  { emoji: '🤝', label: 'Making introductions' },
  { emoji: '🧠', label: 'Sharing knowledge' },
  { emoji: '🎤', label: 'Speaking / events' },
  { emoji: '🧑‍🏫', label: 'Mentoring others' },
  { emoji: '👥', label: 'Hiring talent' },
  { emoji: '🌏', label: 'Community building' },
  { emoji: '✍️', label: 'Content creation' },
  { emoji: '💰', label: 'Investing / fundraising' },
  { emoji: '🎉', label: 'Hosting events' },
];

export const INTEREST_PRESETS = [
  { emoji: '🤝', label: 'Finding collaborators' },
  { emoji: '🧭', label: 'Career advice' },
  { emoji: '💼', label: 'Business development' },
  { emoji: '🎯', label: 'Job opportunities' },
  { emoji: '🌏', label: 'Growing my network' },
  { emoji: '🚀', label: 'Starting a business' },
  { emoji: '📚', label: 'Learning new skills' },
  { emoji: '💰', label: 'Investing / fundraising' },
  { emoji: '🎤', label: 'Speaking / events' },
  { emoji: '🔄', label: 'Matchups' },
  { emoji: '☕', label: '1:1 meetings' },
  { emoji: '🍷', label: 'Small group meetings' },
];
